import { render, staticRenderFns } from "./MemberDisconnectedComponent.vue?vue&type=template&id=4de4c90d&"
import script from "./MemberDisconnectedComponent.vue?vue&type=script&lang=js&"
export * from "./MemberDisconnectedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports